import { useEffect, useState } from "react";
import { findAllImage, findEntityData, findImage } from "../../api/apiService";

const TeamSuccess = () => {
    const [section1, setSection1] = useState();
    const [imageUrls, setImageUrls] = useState([]);
    const findData = async () => {
        const res = await findEntityData("sss_about_team_success");
        setSection1(res?.data?.[0]);
    };

    const renderAllImage = async (id) => {
        if (!id) return [];
        const idArray = Array.isArray(id) ? id : [id];
        const idsParam = idArray.join(",");
        const res = await findAllImage(idsParam);
        return res?.data?.[0]?.data || [];
    };

    useEffect(() => {
        findData();
    }, []);

    useEffect(() => {
        // fetch all image URLs when section1 data changes
        const fetchImages = async () => {
            if (!section1?.data) return;
            const urls = await renderAllImage(section1.data.map(item => item.image));
            setImageUrls(urls);
        };

        fetchImages();
    }, [section1]);
    return (
        <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
                <h2
                    className="text-2xl font-semibold text-[#F37934]"
                    data-aos="zoom-in"
                    data-aos-duration="800"
                    data-aos-easing="ease-out"
                >
                    {section1?.heading}
                </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3  md:flex-row justify-center items-center md:items-stretch gap-6 md:gap-12 mb-16">
                {/* <div className="flex flex-col md:flex-row justify-center items-center md:items-stretch gap-6 md:gap-12 mb-16"> */}
                {section1?.data?.map((item, index) => (
                    <div
                        className="text-center"
                        data-aos="flip-left"
                        data-aos-duration="1000"
                        data-aos-delay="200"
                    >
                        <a
                            href="https://www.linkedin.com/in/rupert-joseph-0947273a/ "
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={imageUrls[index]}
                                alt="arul"
                                className="h-56 w-56 mx-auto mb-4 object-cover object-top cursor-pointer rounded-xl"
                            />
                        </a>

                        <h3 className="font-bold">{item?.name}</h3>
                        <p className="font-quicksand">{item?.designation}</p>
                    </div>
                ))}
            </div>
            <div className="max-w-5xl mx-auto space-y-10 px-4 text-center md:text-left">
                <p className="mx-auto text-center md:text-left pb-4">
                    {section1?.content}
                </p>

                <div className="team_success" data-aos="slide-right" data-aos-duration="1000" data-aos-easing="ease-out-cubic">
                    <div dangerouslySetInnerHTML={{ __html: section1?.content2 }} />
                </div>
            </div>
        </div>
    )
}

export default TeamSuccess
